::ng-deep mat-checkbox .mat-checkbox-layout{align-items:start}::ng-deep mat-checkbox .mat-checkbox-inner-container{top:3px}
/*# sourceMappingURL=audit-case-archive-dialog.component-WQXXCXW4.css.map */
